<template>
  <div class="intro">
    <h1 class="intro__heading" v-html="this.heading" />
    <p class="intro__description" v-html="this.description" />
  </div>
</template>

<script>
export default {
  name: 'AppNav',
  props: {
    heading: {
      type: String,
      default: ''
    },
    description: {
      type: String,
      default: ''
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/templates/components/Intro.vue